<template>
  <div>
    <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    />
    <div class="adress-main">
      <div
        class="address-item"
        v-for="item in adressList"
        :key="item.id"
        @click="handleStronge(item)"
      >
        <div class="address-icon">{{ item.name[0] || "" }}</div>
        <div style="width: 100%">
          <div class="item-count">
            <div class="item-user">
              <div>{{ item.name }}</div>
              <div>{{ item.phone }}</div>
            </div>
            <div style="display: flex; width: 40%">
              <van-button
                type="info"
                size="mini"
                style="margin-left: 2%"
                @click.stop="handleEditAddress(item)"
                >编辑</van-button
              >
              <van-button
                type="danger"
                size="mini"
                @click.stop="handleDelete(item)"
                >删除</van-button
              >
            </div>
          </div>
          <div class="adress">{{ item.address }}</div>
        </div>
      </div>

      <van-button
        type="primary"
        size="large"
        style="margin-top: 50%"
        @click="handleShow"
        >添加地址</van-button
      >

      <van-dialog
        v-model="showDialog"
        confirmButtonColor="#218DFA"
        :title="decide ? '编辑地址' : '添加地址'"
        :before-close="onBeforeClose"
        show-cancel-button
        @confirm="handleAddress"
      >
        <van-row>
          <van-col span="24">
            <van-cell-group>
              <van-field label="姓名" required placeholder="请输入姓名">
                <template #input>
                  <van-row>
                    <van-col span="12">
                      <input
                        v-model="username"
                        type="text"
                        class="phoneinput"
                        placeholder="请输入姓名"
                      />
                    </van-col>
                    <van-col span="12">
                      <van-radio-group v-model="radio" direction="horizontal">
                        <van-radio name="1">先生</van-radio>
                        <van-radio name="2">女生</van-radio>
                      </van-radio-group>
                    </van-col>
                  </van-row>
                </template>
              </van-field>
            </van-cell-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-cell-group>
              <van-field
                v-model="phonenumber"
                label="手机号"
                required
                placeholder="请输入手机号"
                :rules="[{ required: true, message: '请填写手机号码' }]"
              />
            </van-cell-group>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-cell-group class="border">
              <van-field
                v-model="address"
                required
                type="textarea"
                autosize
                label="地址"
                placeholder="请输入地址"
              />
            </van-cell-group>
          </van-col>
        </van-row>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      adressList: [],
      clickFlag: false,
      showDialog: false,
      username: "",
      address: "",
      radio: "1",
      phonenumber: "",
      decide: false,
      editId: "",
      shopId: "",
      customerId: "",
    };
  },
  created() {
    this.shopId = localStorage.getItem("shopId");
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId");
  },
  mounted() {
    this.getUserAdress();
  },
  methods: {
    //新建地址
    handleCreateAdress() {
      this.$router.push({
        path: "/merchants/address/Address",
      });
    },
    //选择地址
    handleSelecr(data) {
      console.log(data);
      sessionStorage.setItem("adress", JSON.stringify(data));
      this.$router.push({
        path: "/order/submit",
        query: {
          mealPeriodTime: this.$route.query.mealPeriodTime,
          mealHourName: this.$route.query.mealHourName,
          mealHourTime: this.$route.query.mealHourTime,
        },
      });
    },
    //获取地址
    getUserAdress() {
      let data = {
        shopId: this.shopId,
        customerId: this.customerId,
        groupId: 1,
      };
      this.$authAjax
        .post("/api/wxapp/reserve/getCustomerAddress", data)
        .then((res) => {
          let { data } = res.data;
          this.adressList = data;
        });
    },
    //编辑地址
    handleEditAdress() {
      console.log("##12");
    },
    onBeforeClose(action, done) {
      if (action == "confirm") {
        return done(false);
      } else {
        return done();
      }
    },
    //添加地址
    handleShow() {
      this.showDialog = true;
      this.decide = false;
    },
    handleAddress() {
      if (!this.username) {
        return this.$toast("请输入姓名");
      } else if (!this.phonenumber) {
        return this.$toast("请输入手机号");
      } else if (!this.address) {
        return this.$toast("请输入地址");
      }
      if (this.decide) {
        let data = {
          customerId: this.customerId,
          address: this.address,
          gender: this.radio,
          groupId: 1,
          id: this.editId,
          isDefault: "0",
          name: this.username,
          phone: this.phonenumber,
          shopId: this.shopId,
        };
        this.$authAjax
          .post("/api/wxapp/reserve/updateAddress", data)
          .then((res) => {
            if (res.data.code == 200) {
              this.$toast.success("编辑成功");
              this.showDialog = false;
              this.clearDataList();
            }
            this.getUserAdress();
          });
      } else {
        let data = {
          customerId: this.customerId,
          address: this.address,
          gender: this.radio,
          groupId: 1,
          id: "",
          isDefault: "0",
          name: this.username,
          phone: this.phonenumber,
          shopId: this.shopId,
        };
        this.$authAjax
          .post("/api/wxapp/reserve/addAddress", data)
          .then((res) => {
            if (res.data.code == 200) {
              this.$toast.success("添加成功");
              this.showDialog = false;
              this.clearDataList();
            }
            this.getUserAdress();
          });
      }
    },
    //清空数据
    clearDataList() {
      this.username = "";
      this.address = "";
      this.radio = "1";
      this.phonenumber = "";
    },
    //删除地址
    handleDelete(item) {
      console.log(item);
      Dialog.confirm({
        title: "删除地址",
        message: "是否删除该地址？",
      })
        .then(() => {
          let data = {
            id: item.id,
          };
          this.$authAjax
            .post("/api/wxapp/reserve/deleteAddress", data)
            .then((res) => {
              if (res.data.code == 200) {
                this.$toast.success("删除成功");
                this.getUserAdress();
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //编辑地址
    handleEditAddress(item) {
      this.decide = true;
      this.showDialog = true;
      this.editId = item.id;
      this.username = item.name;
      this.radio = item.gender.toString();
      this.address = item.address;
      this.phonenumber = item.phone;
    },
    //存储选择的地址
    handleStronge(item) {
      console.log(item);
      sessionStorage.setItem("adress", JSON.stringify(item));
      this.$router.push({
        path: "/order/submit",
        query: {
          mealPeriodTime: this.$route.query.mealPeriodTime,
          mealHourName: this.$route.query.mealHourName,
          mealHourTime: this.$route.query.mealHourTime,
          branchId: this.$route.query.branchId,
          branchName: this.$route.query.branchName,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.adress-main {
  width: 100%;
  height: calc(100vh - 45px);
  background: #f2f2f2;
  margin-top: 45px;
  box-sizing: border-box;
  overflow: auto;
  padding: 10px;
  .noneClick {
    pointer-events: none;
  }
  .address-item {
    padding: 10px 5px;
    background: #fff;
    border-radius: 5px;
    margin-top: 8px;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    .item-count {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 5px;
      width: 100%;
      .item-user {
        display: flex;
        align-items: center;
        div:nth-child(1) {
          font-size: 16px;
        }
        div:nth-child(2) {
          font-size: 16px;
          margin-left: 15px;
        }
      }
    }
    .adress {
      padding: 0 5px;
      margin-top: 5px;
      font-size: 14px;
    }
    .address-icon {
      font-size: 20px;
      font-weight: bold;
      width: 38px;
      height: 38px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f4f5f6;
      background-image: linear-gradient(15deg, #cfd9df 0%, #e2ebf0 100%);
      margin-right: 8px;
      font-variant: small-caps;
      color: #565754;
    }
  }
  .phoneinput {
    border: none;
  }
}
</style>
